import { AnimatePresence, motion } from 'framer-motion'

type BalloonTextProps = {
    active: boolean
    text: string
}
/** An ephemeral message that floats up and fades out. eg. on a button to
 * indicate a successful action.
 */
export function BalloonText(props: BalloonTextProps) {
    return (
        <AnimatePresence>
            {props.active && (
                <motion.div
                    initial={{ y: '0%', opacity: 1 }}
                    animate={{
                        y: ['-70%', '-90%', '-110%'],
                        opacity: [0.7, 0.6, 0],
                        scale: [1.1, 1.2, 1.3],
                    }}
                    transition={{ duration: 0.7, ease: 'linear' }}
                    className="absolute inset-0 z-40 flex items-center justify-center text-[12px] text-muse-yellow pointer-events-none"
                >
                    {props.text}
                </motion.div>
            )}
        </AnimatePresence>
    )
}
